import { useBreakpoint } from '../providers';
import { useMapContext } from '../hooks/MapProvider';
import styled from 'styled-components6';
import { Else, If, Then } from 'react-if';

const TitleContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: var(--rwl-spacing-sm);
`;

export const Title = (): JSX.Element => {
    const { isBelowBreakpoint } = useBreakpoint();
    const { serviceAreas } = useMapContext();
    const totalJobs = serviceAreas.reduce(
        (acc, serviceArea) => acc + serviceArea.jobCount,
        0
    );
    if (totalJobs === 0) return <></>;

    return (
        <TitleContainer>
            <If condition={isBelowBreakpoint('sm')}>
                <Then>
                    {/* have to use <h3> so we can inherit site styling for this title */}
                    <h3
                        style={{ margin: 0, fontSize: '1.75rem' }}
                        className="rwl-neighborhood-header"
                    >
                        Check out our work in your neighborhood
                    </h3>
                </Then>
                <Else>
                    {/* have to use <h2> so we can inherit site styling for this title */}
                    <h2
                        style={{ margin: 0, fontSize: '2rem' }}
                        className="rwl-neighborhood-header"
                    >
                        Check out our work in your neighborhood
                    </h2>
                </Else>
            </If>
        </TitleContainer>
    );
};
